import { usePage } from "@inertiajs/react"
import type { Market } from "@/lib/useMarket"
import { activeHref, buildNavLinks, type NavSection } from "./navLinks"

// The Menu's sections for the current viewer, and the href of the link to
// light on the current URL. Shared by NavMenu and PageTabs.
export function useNavSections(): { sections: NavSection[]; active: string | null } {
  const { url, props } = usePage<{
    remembered_market?: Market | null
    all_markets_picked?: boolean
    wholesale_market_ids?: string[]
  }>()
  const sections = buildNavLinks({
    market: props.remembered_market ?? null,
    allMarketsPicked: props.all_markets_picked ?? false,
    wholesaleMarketIds: props.wholesale_market_ids ?? [],
    // Settings are built by UserMenu; buildNavLinks does not read these.
    canManageOrgNodes: false,
    canManageProductGroups: false,
    canManageWarehouses: false,
    canManageRoles: false,
  })
  return { sections, active: activeHref(sections.flatMap((s) => s.links), url) }
}
